import type { DomainSystem } from '@/core/app/dispatch';
import { achievementSystem } from './achievements';
import { cozinessSystem } from './coziness';
import { ordersSystem } from './orders';
import { statsSystem } from './stats';
import { suggestionSystem } from './suggestions';
import { unlockSystem } from './unlocks';
import { visitsSystem } from './visits';
import { neighborhoodSystem } from './neighborhood';
import { studioSystem } from './studio';

/**
 * Post-command systems in the FIXED order of content-schemas §13.3:
 * stats → coziness → (friendship) → achievements → suggestions → unlocks, then reactions to fresh unlocks
 * (the first NPC order, the first studio booking) and neighbours' Home visits once they have met (§14.11).
 */
export const DOMAIN_SYSTEMS: readonly DomainSystem[] = [
  statsSystem,
  cozinessSystem,
  achievementSystem,
  suggestionSystem,
  unlockSystem,
  ordersSystem,
  visitsSystem,
  neighborhoodSystem,
  studioSystem,
];
